import MarkdownIt from "markdown-it";
import markdownItAttrs from "markdown-it-attrs";
import markdownItFa from "markdown-it-fontawesome";

const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true
});

const mdFull = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true
})
  .use(markdownItAttrs)
  .use(markdownItFa);

export const markdown = raw => {
  return md.render(raw);
};

export const markdownFull = raw => {
  let html = mdFull.render(raw);
  html = html.replace(
    /<table>/gi,
    '<table style="width: auto" class="table table-sm table-striped">'
  );
  return html;
};

export const urlDisplay = url => {
  return url.replace(/http(s?):\/\/(www\.)?/, "");
};
